module.exports = __webpack_public_path__ + "static/media/problem_graph.429a30f1.png";


//////////////////
// WEBPACK FOOTER
// ./src/Jiggle/Problems/img/problem_graph.png
// module id = 267
// module chunks = 0